// extracted by mini-css-extract-plugin
export var body = "_eg-0";
export var sectionHeader = "_eg-4";
export var shortcutColumns = "_eg-2";
export var shortcutList = "_eg-1";
export var shortcutSection = "_eg-3";